.button {
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--radio-image-padding);
  cursor: pointer;
  background-color: var(--radio-image-background);
  border: 1px solid var(--radio-image-border-color);
  border-radius: var(--radio-image-radius);
  transition: background-color 150ms ease, border-color 150ms ease;
}

.body {
  flex: 1;
  margin-left: var(--radio-image-body-margin);
}
